import React, { useEffect, useState } from 'react';
import Loader from '../../common/Loader';
import { useFetchCheckbetTicket } from '../../data/fetchCheckbetTicket';
import { getLabel } from '../../data/labels';
import BetInfo from './BetInfo';
import EventsList from './EventsList';
import ToggleNotifications from './my-bets-layout-3/ToggleNotifications';
import { getConfiguration } from '../utils/configuration';
import ExternalDetailsLink from './ExternalDetailsLink';

function SingleBetTicket(props) {
    const [data, setData] = useState(null);

    const [state, dispatch] = useFetchCheckbetTicket(props.ticket.id, props.toggled, props.ticket.isLive, false, true);
    const conf = getConfiguration();

    useEffect(() => {
        if (state.data != null && !state.isError) {
            setData(state.data);
        }
    }, [state.data, state.isError]);

    useEffect(() => {
        if (data != null && !props.toggled) {
            setData(null);
        }
    }, [props.toggled]);

    function toggleMatches() {
        props.toggleTicket(props.ticket.id);
    }

    return (
        <div className="mybet-container d-flex flex-column">
            <div className="d-flex justify-content-space-between align-items-center margine-su-giu bold pointer details-toggle" onClick={toggleMatches}>
                <span className="text-big bold">{getLabel('mybets.singola')}</span>
                <span className="margin-auto bold">
                    {props.ticket.funBonus &&
                        <span className="cg-mybet-funbonus">{getLabel('mybets.funbonus')}</span>
                    }
                    {props.ticket.freeBet &&
                        <span className="cg-mybet-funbonus">{getLabel('mybets.freebet')}</span>
                    }
                    {props.ticket.isBetBuilder &&
                        <span className="cg-mybet-funbonus">{getLabel('betbuilder.title')}</span>
                    }
                </span>
                <span className="visibility-hidden">{getLabel('mybets.singola')}</span>
                <ExternalDetailsLink ticketId={props.ticket.id} />
                <span>{getLabel('mybets.dettagli')} <span onClick={toggleMatches}>{props.toggled ? '-' : '+'}</span></span>
            </div>
            <hr />
            {props.toggled &&
                (data == null ?
                    <Loader error={state.isError} />
                    :
                    <div  className="mybet-events-container" >
                     {conf.pnc?.enabled && <ToggleNotifications state={state} dispatch={dispatch} />}
                        <EventsList events={data.events} isBetBuilder={props.ticket.isBetBuilder} />
                    </div>
                )
            }
            <div className="light-grey-bg">
                <BetInfo ticket={props.ticket} isCheckbet={false} isBetBuilder={props.ticket.isBetBuilder} />
            </div>
        </div>
    );
}

export default SingleBetTicket;